import { IMAGES_BASE_URL } from '../imagesBaseUrl';

export interface TravelLocation {
  slug: string;
  name: string;
  country: string;
  position: [number, number];
  image: string;
  description: string;
  dateRange: string;
}

export const locations: TravelLocation[] = [
  {
    slug: 'ubud',
    name: 'Ubud',
    country: 'Indonesia',
    position: [-8.505814, 115.262249],
    image: `${IMAGES_BASE_URL}/images/ubud/photo28.jpg`,
    description: '⭐ Mount Batur ⭐',
    dateRange: '1-5 September 2025',
  },
  {
    slug: 'canggu',
    name: 'Canggu',
    country: 'Indonesia',
    position: [-8.661099, 115.132674],
    image: `${IMAGES_BASE_URL}/images/canggu/photo15.jpg`,
    description: '⭐ Sunset at La brisa ⭐',
    dateRange: '5-8 September 2025',
  },
  {
    slug: 'uluwatu',
    name: 'Uluwatu',
    country: 'Indonesia',
    position: [-8.825843, 115.105631],
    image: `${IMAGES_BASE_URL}/images/uluwatu/photo14.JPG`,
    description: '⭐ Surfing ⭐',
    dateRange: 'Dates TBD',
  },
  {
    slug: 'nusa lembongan',
    name: 'Nusa Lembongan',
    country: 'Indonesia',
    position: [-8.678698, 115.455605],
    image: `${IMAGES_BASE_URL}/images/nusa lembongan/photo7.jpg`,
    description: '⭐ Devils Tears ⭐',
    dateRange: 'Dates TBD',
  },
  {
    slug: 'gili air',
    name: 'Gili Air',
    country: 'Indonesia',
    position: [-8.358527, 116.081744],
    image: `${IMAGES_BASE_URL}/images/gili air/photo8.jpg`,
    description: '⭐ Snorkeling ⭐',
    dateRange: 'Dates TBD',
  },
  {
    slug: 'kuala lumpur',
    name: 'Kuala Lumpur',
    country: 'Malaysia',
    position: [3.128561, 101.707927],
    image: `${IMAGES_BASE_URL}/images/kuala lumpur/photo17.jpg`,
    description: '⭐ Petronas Twin Towers ⭐',
    dateRange: 'Dates TBD',
  },
  {
    slug: 'george town',
    name: 'George Town',
    country: 'Malaysia',
    position: [5.409812, 100.324729],
    image: `${IMAGES_BASE_URL}/images/george town/photo23.jpg`,
    description: '⭐ Penang Hill ⭐',
    dateRange: 'Dates TBD',
  },
  {
    slug: 'langkawi',
    name: 'Langkawi',
    country: 'Malaysia',
    position: [6.362032, 99.806771],
    image: `${IMAGES_BASE_URL}/images/langkawi/photo30.jpg`,
    description: '⭐ Beach Fire Shows ⭐',
    dateRange: 'Dates TBD',
  },
  {
    slug: 'da nang',
    name: 'Da Nang',
    country: 'Vietnam',
    position: [16.048863, 108.213192],
    image: `${IMAGES_BASE_URL}/images/da nang/photo8.jpg`,
    description: '⭐ Monkey Mountain ⭐',
    dateRange: 'Dates TBD',
  },
  {
    slug: 'hoi an',
    name: 'Hoi An',
    country: 'Vietnam',
    position: [15.879028, 108.328460],
    image: `${IMAGES_BASE_URL}/images/hoi an/photo32.jpg`,
    description: '⭐ Ba Na Hills ⭐',
    dateRange: 'Dates TBD',
  },
];
